import React, { useContext, useEffect, useState } from "react";
import LoaderComponent from "../components/LoaderComponent";
import { AuthContext } from "../auth/AuthContext";
import { httpPost } from "../lib/apiClients";
import { AxiosResponse } from "axios";
import { useNavigate, useSearchParams } from "react-router-dom";
import { UserDataContext } from "../context/UserDataContext";
import { Environment } from "../utils/environments";

export default function GetCoupon() {
  const { currentUser } = useContext(AuthContext);
  const [searchParams, setSearchParams] = useSearchParams();
  const { memberData, fetchUserData, setCouponData } =
    useContext(UserDataContext);

  const navigate = useNavigate();
  const couponCode = searchParams.get("couponCode")
    ? searchParams.get("couponCode")
    : undefined;

  useEffect(() => {
    document.title = "クーポン獲得 | じぶん専用IT相談室";
    if (!couponCode) {
      navigate(`/error?code=404`);
      return;
    }

    fetchCouponData();
  }, [currentUser, memberData]);
  /**
   * Fetches user data and handles coupon retrieval.
   *
   */
  async function fetchCouponData() {
    console.log(currentUser);
    if (currentUser === undefined) {
      return;
    }

    if (currentUser === null) {
      navigate("/login", {
        state: {
          from: window.location.pathname,
          search: window.location.search,
        },
      });
    }
    if (!memberData) {
      return;
    }
    try {
      await httpPost({
        pathName: "get-coupon",
        bodyParams: {
          couponCode: couponCode,
          memberId: memberData && memberData.memberId,
        },
      }).then((response: AxiosResponse<any>) => {
        var data = response.data;
        setCouponData(null);
        fetchUserData();
        navigate("/");
      });
    } catch (error) {
      if (Environment.getBuildType() != "prod") {
        console.log(error);
      }
      navigate(`/error?code=getCoupon`);
    }
  }
  return <LoaderComponent />;
}
